module.exports = __webpack_public_path__ + "static/media/silkycloud-pink-4.39413f35.png";